import { Pipe, PipeTransform } from '@angular/core';

import { isSharedWithOthers } from '../utils/sharing-utils';

/**
 * Returns true if the item is shared with other users.
 *
 * Params:
 *   string: The string with words to be abbreviated.
 */
@Pipe({
    name: 'isSharedWithOthers',
    standalone: false,
})
export class IsSharedWithOthersPipe implements PipeTransform {
    transform(item: Record<string, any> | null | undefined): boolean {
        return isSharedWithOthers(item);
    }
}
